import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useLang } from "@/i18n/LanguageContext";

const API = process.env.REACT_APP_BACKEND_URL;

export const useAnalyticsTracker = () => {
  const { pathname } = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    if (!API) return;
    const path = pathname;
    const referrer = typeof document !== "undefined" ? document.referrer || "" : "";
    const screen = typeof window !== "undefined" ? `${window.innerWidth}x${window.innerHeight}` : "";
    const controller = new AbortController();
    axios
      .post(`${API}/api/analytics/track`, { path, referrer, lang, screen }, { signal: controller.signal, timeout: 4000 })
      .catch(() => { /* silent — analytics never break UX */ });
    return () => controller.abort();
  }, [pathname, lang]);
};
